// 회사 목록 행 「지원 접속」(사용자 결정 10-29) — 병원·제조사(기공소)·STUDIO·리셀러 목록이 같은 창(SupportEntryDialog)을 엶.
// 권한 표(perms)가 없으면(옛 inapi) 숨기지 않음 — 서버가 판정. supportAccess 가 꺼진 동안(배포 날)은 숨김(main 과 같게)
import { can, permsOf } from "@/utils/perm";
import { supportAccessOn } from "@/utils/supportAccess";
import SupportEntryDialog from "@/views/components/SupportEntryDialog.vue";

export default {
  components: { SupportEntryDialog },
  data() {
    return { supportOpen: false, supportTarget: { id: "", type: "", name: "" } };
  },
  computed: {
    canSupportEntry() {
      const i = this.$store.state.introspect;
      return supportAccessOn(i) && can(permsOf(i), "ops.support.edit");
    },
  },
  methods: {
    openSupport(record, type) {
      this.supportTarget = { id: String(record._id), type, name: record.name || "" };
      this.supportOpen = true;
    },
  },
};
